import { motion } from 'framer-motion';
import { fadeSlideIn } from '../animation';
import { useTranslation } from 'react-i18next';
import { useClientContext } from '../../ClientContext';
import { displayInsurancePolicySubType, AddInsuranceForm } from '../../Insurance';
import { InsurancePolicySubtype, InsurancePolicyType } from '../../generated/graphql';
import { SideOverHeaderNew, SideOverHeading, useSideOverContext } from '../components';

interface CreateInsuranceSideOverPageProps {
  exitRoute: string | undefined;
  policyType: InsurancePolicyType;
  policySubtype: InsurancePolicySubtype;
}

export function CreateInsuranceSideOverPage({
  policySubtype,
  policyType,
  exitRoute,
}: CreateInsuranceSideOverPageProps) {
  const { closeSideOver } = useSideOverContext();
  const { t: tInsurance } = useTranslation('insurance');
  const { clientID, firmID, householdID } = useClientContext();

  return (
    <>
      <SideOverHeaderNew withShadow className="pl-4 mt-0" exit={exitRoute} />
      <div className="px-6 sm:px-12">
        <SideOverHeading className="mb-14" heading={displayInsurancePolicySubType(policySubtype, tInsurance)} />
        <motion.div key="InsuranceForm_form" {...fadeSlideIn()}>
          <AddInsuranceForm
            firmId={firmID}
            firmClientId={clientID}
            householdID={householdID}
            onSuccess={closeSideOver}
            insurancePolicyType={policyType}
            insurancePolicySubtype={policySubtype}
          />
        </motion.div>
      </div>
    </>
  );
}
